import React, { ReactNode } from 'react';
import { Card, Typography, Box, useMediaQuery, useTheme } from '@mui/material';
import { useMobilePreview } from '../context/MobilePreviewContext';

interface CalculatorCardProps {
  title: string;
  description?: string;
  children: ReactNode;
}

const CalculatorCard: React.FC<CalculatorCardProps> = ({
  title,
  description,
  children,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const { isMobilePreview } = useMobilePreview();
  const isMobileView = isMobile || isMobilePreview;

  return (
    <Card
      sx={{
        p: isMobileView ? 2 : 3,
        background: undefined,
        backdropFilter: undefined,
        boxShadow: isMobileView ? 1 : 2,
        width: '100%',
        maxWidth: '100%',
      }}
    >
      <Box sx={{ mb: isMobileView ? 2 : 3 }}>
        <Typography 
          variant={isMobileView ? "h5" : "h4"} 
          component="h1" 
          gutterBottom
          sx={{
            fontSize: isMobileView ? '1.5rem' : undefined,
            fontWeight: 600,
          }}
        >
          {title}
        </Typography>
        {description && (
          <Typography 
            variant="body2" 
            color="text.secondary"
            sx={{
              fontSize: isMobileView ? '0.875rem' : undefined,
            }}
          >
            {description}
          </Typography>
        )}
      </Box>
      {children}
    </Card>
  );
};

export default CalculatorCard;
